import { render, staticRenderFns } from "./MusteriSenetleri.vue?vue&type=template&id=22ffff94&scoped=true"
import script from "./MusteriSenetleri.vue?vue&type=script&lang=js"
export * from "./MusteriSenetleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffff94",
  null
  
)

export default component.exports